import { h, createRef } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState, useEffect, StateUpdater } from 'preact/hooks';
import { useContext } from './context';
import { SaveForLater } from '../../../types/web-components';

const sharedState: StateUpdater<boolean>[] = [];

export const component : SaveForLater = ({ resourceid, children }) => {
  const [saved, setSaved] = useState(false);

  const ref: any = createRef();

  useContext(({ user }) => setSaved(user?.saved));

  useEffect(() => {
    sharedState.push(setSaved);
  }, []);

  useEffect(() => {
    const icon = ref.current.querySelector('i.tds-btn__icon');
    const iconClass = saved ? 'tds-btn__icon--tds-bookmark-filled' : 'tds-btn__icon--tds-bookmark';
    if (icon) {
      icon.className = `tds-btn__icon ${iconClass}`;
    }

    const handleClick = async () => {
      const method = saved ? 'DELETE' : 'POST';

      // Don't do anything with the response yet, because it's not working.
      await (await fetch(`api/saved/${resourceid}`, { method })).json();

      /* The component appears on the page multiple times. Set the state of each instance of it. */
      for (const setState of sharedState) setState(!saved);
    };

    const button = ref.current.querySelector('.tds-btn--secondary');
    button.addEventListener('click', handleClick);

    return () => button.removeEventListener('click', handleClick);
  }, [saved]);

  return <div className='rdp-save-for-later' ref={ref}>{children}</div>;
};

register(component, 'tes-save-for-later', [], { shadow: false });
